module.exports = __webpack_public_path__ + "static/media/0323_IMG_FE_LES_MURS_CHROMATIC_CH2_1019.24aca2fd.png";